import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root',
})
export class UserApi extends ApiCommon {
  getUsers(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;
    builder.selectFields = [
      'username',
      'lastName',
      'firstName',
      'twoFactorAuth',
      'roles',
      'dealers',
      'status',
      'auth',
      'organization',
      'organizationName',
      'tel',
      'userType',
      'lastLogin',
    ];

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.user.getUsers(builder.build());
  }

  exportUsers(builder): Observable<any> {
    return this.apiServer.user.exportUsers(builder);
  }

  getUser(username): Observable<any> {
    return this.apiServer.user.getUser(username);
  }

  getUserByBpNo(bpNo): Observable<any> {
    return this.apiServer.user.getUserByBpNo(bpNo);
  }

  updateUserBpsById(updateUserData): Observable<any> {
    return this.apiServer.user.updateUserBpsById(updateUserData);
  }

  getContact(bpNo): Observable<any> {
    return this.apiServer.user.getContact(bpNo);
  }

  saveUser(user): Observable<any> {
    return this.apiServer.user.saveUser(user);
  }

  getAssignedDealers(username): Observable<any> {
    return this.apiServer.user.getAssignedDealers(username);
  }

  saveUserAddressFavorite(user, newAddress): Observable<any> {
    return this.apiServer.user.saveUserAddressFavorite(user, newAddress);
  }

  deleteUserAddressFavorite(user, newAddress): Observable<any> {
    return this.apiServer.user.deleteUserAddressFavorite(user, newAddress);
  }

  assignDealers(username, assignList): Observable<any> {
    return this.apiServer.user.assignDealers(username, assignList);
  }

  unAssignDealers(username, unAssignList): Observable<any> {
    return this.apiServer.user.unAssignDealers(username, unAssignList);
  }

  getMyLocationAliases(username): Observable<any> {
    return this.apiServer.user.getMyLocationAliases(username);
  }

  assignLocationAliases(username, assignLocationAliases): Observable<any> {
    return this.apiServer.user.assignLocationAliases(
      username,
      assignLocationAliases,
    );
  }

  unAssignLocationAliases(username, unAssignLocationAliases): Observable<any> {
    return this.apiServer.user.unAssignLocationAliases(
      username,
      unAssignLocationAliases,
    );
  }

  checkDuplicateEmail(username): Observable<any> {
    return this.apiServer.user.checkDuplicateEmail(username);
  }

  createB2bCustomer(customer): Observable<any> {
    return this.apiServer.user.createB2bCustomer(customer);
  }

  getNewCustomers(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;
    //builder.selectFields = ['bpNo', 'name', 'address', 'auth', 'contacts', 'tel', 'email', 'hq', 'hqBpNo', 'status', 'onboarding', 'bpType', 'distributorName'];
    builder.selectFields = [
      'username',
      'address',
      'tel',
      'ext',
      'status',
      'onboarding',
      'userType',
      'firstName',
      'lastName',
      'b2bCompany',
    ];

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.user.getNewCustomers(builder.build());
  }

  saveB2bUser(user): Observable<any> {
    return this.apiServer.user.saveB2bUser(user);
  }

  getSimpleProfile(username): Observable<any> {
    return this.apiServer.user.getSimpleProfile(username);
  }

  saveB2bSimpleProfile(user): Observable<any> {
    return this.apiServer.user.saveB2bSimpleProfile(user);
  }

  getB2bUsers(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;
    builder.selectFields = [
      'username',
      'lastName',
      'firstName',
      'twoFactorAuth',
      'roles',
      'dealers',
      'status',
      'auth',
      'organization',
      'organizationName',
      'tel',
      'userType',
      'lastLogin',
      'partnerOrganization',
      'inquiryTypes',
    ];

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.user.getB2bUsers(builder.build());
  }

  updateB2bRequestStatus(username, userInfo): Observable<any> {
    return this.apiServer.user.updateB2bRequestStatus(username, userInfo);
  }

  unlockUserAccount(username): Observable<any> {
    return this.apiServer.user.unlockUserAccount(username);
  }

  updateInquiryType(userId, inquiryTypes) {
    return this.apiServer.user.updateInquiryTypes(userId, inquiryTypes);
  }

  changePassword(userId, passwordData): Observable<any> {
    return this.apiServer.user.changePassword(userId, passwordData);
  }

  getUserActivitySummary(data): Observable<any> {
    return this.apiServer.user.getUserActivitySummary(data);
  }

  getDealerActivitySummary(data): Observable<any> {
    return this.apiServer.dealer.getDealerActivitySummary(data);
  }
}
